<template>
    <div class="icon-Chevron-Up"></div>
</template>